<ra-modal [title]="'mcp.intro.modalTitle' | translate" [size]="'xlarge'" (close)="onClose.emit()">
    <div class="split">
        <!-- Painel da foto. Decorativo, some no estreito para o conteúdo respirar -->
        <aside class="hero" aria-hidden="true">
            <div class="hero-shade"></div>
            <div class="hero-text">
                <h2 class="ra-label-l bold">{{ 'mcp.intro.heroTitle' | translate }}</h2>
                <p class="ra-label-s">{{ 'mcp.intro.heroMessage' | translate }}</p>
            </div>
        </aside>

        <div class="panel">
            <span class="ra-label-xs tag">{{ 'mcp.intro.tag' | translate }}</span>
            <h3 class="ra-label-m bold intro-title">{{ 'mcp.intro.title' | translate }}</h3>
            <p class="ra-label-s intro">{{ 'mcp.intro.message' | translate }}</p>

            <ol class="howto">
                <li class="ra-label-s">{{ 'mcp.intro.step1' | translate }}</li>
                <li class="ra-label-s">{{ 'mcp.intro.step2' | translate }}</li>
                <li class="ra-label-s">{{ 'mcp.intro.step3' | translate }}</li>
            </ol>

            <div class="container-buttons">
                <ra-button
                    [id]="'button-mcp-intro-dismiss'"
                    [label]="'mcp.intro.dismiss' | translate"
                    [type]="'primary-outline'"
                    (click)="onClose.emit()" />
                <ra-button
                    [id]="'button-mcp-intro-open'"
                    [label]="'mcp.intro.open' | translate"
                    (click)="open()" />
            </div>
        </div>
    </div>
</ra-modal>
